export function toRatio(rate?: number) {
  return `${((rate || 0) * 100).toFixed(2)}`
}
